/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Widget } from 'datastake-daf/dist/components';
import { getConfig } from './config';
import DetailsList from '../../../../../../../components/dashboards/components/DetailsList';

const DataValue = ({
  projectData = null,
  t = (t) => t,
  data = {}
}) => {
  const [loading, setLoading] = useState(true);
  const _config = getConfig({ loading, t, projectData, data});

  useEffect(() => {
    if (projectData && data.uniqueInformationSubjects) {
      setLoading(false);
    } else if (!loading) {
      setLoading(true);
    }
  }, [projectData, data]);

  return (
    <Widget className="with-border-header" title={t('Data Value')}>
      <DetailsList config={_config} />
    </Widget>
  );
}

export default DataValue;
